/**
 * The "Bewegung" switch of the Schulportal (settings page, owner s18). One source of truth: the attribute
 * data-bewegung="aus" on the document root while /schule is mounted. The CSS (index.css, .sp-*), the WAAPI helpers
 * (buehne.ts / dialogAbgang.ts), the hero film, the tilt and the count-up all read that attribute, so "off" stops
 * every motion exactly like prefers-reduced-motion. The choice is stored per device in localStorage (default: on).
 * No React in this file: the hook lives in useBewegung.ts.
 */

export const BEWEGUNG_SCHLUESSEL = 'sp-bewegung'
export const BEWEGUNG_ATTRIBUT = 'data-bewegung'
export const BEWEGUNG_EVENT = 'sp-bewegung-geaendert'

type Speicher = Pick<Storage, 'getItem' | 'setItem'>

const lokal = (): Speicher | null => {
  try { return typeof window !== 'undefined' ? window.localStorage : null } catch { return null }
}

/** Stored choice: only the stored text "aus" turns motion off. Anything else, a blocked storage or a missing value = on. */
export function bewegungLesen(speicher: Speicher | null = lokal()): boolean {
  try { return speicher?.getItem(BEWEGUNG_SCHLUESSEL) !== 'aus' } catch { return true }
}

/** Store the choice. A blocked storage is ignored: the attribute still holds the choice for this page load. */
export function bewegungSpeichern(an: boolean, speicher: Speicher | null = lokal()) {
  try { speicher?.setItem(BEWEGUNG_SCHLUESSEL, an ? 'an' : 'aus') } catch { /* storage blocked: choice stays for this page load */ }
}

/** Put the choice on the root element (the single place the CSS and the JS helpers read). */
export function bewegungAnwenden(an: boolean, wurzel: Element | null = typeof document !== 'undefined' ? document.documentElement : null) {
  if (!wurzel) return
  if (an) wurzel.removeAttribute(BEWEGUNG_ATTRIBUT)
  else wurzel.setAttribute(BEWEGUNG_ATTRIBUT, 'aus')
}

/** True when the switch is OFF (reads the attribute; false without a document). */
export function bewegungAusgeschaltet(wurzel: Element | null = typeof document !== 'undefined' ? document.documentElement : null): boolean {
  return wurzel?.getAttribute(BEWEGUNG_ATTRIBUT) === 'aus'
}

/** Set + store + tell subscribers. */
export function bewegungSetzen(an: boolean) {
  bewegungSpeichern(an)
  bewegungAnwenden(an)
  if (typeof window !== 'undefined') window.dispatchEvent(new Event(BEWEGUNG_EVENT))
}
